import { useCallback, useState } from 'react'
import { LoadingSkeleton } from 'common-components'
import * as Styled from './styled'

interface IProps {
  isOpen: boolean
  onClose: () => void
  url: string
  buttonLabel?: string
  buttonOnClick?: () => void
  aspectRatio: string
}

export const ImagePreviewPopup: React.FC<IProps> = ({
  isOpen,
  onClose,
  url,
  buttonLabel,
  buttonOnClick,
  aspectRatio
}) => {
  const [isImageLoading, setIsImageLoading] = useState<boolean>(true)

  const handleButtonClick = useCallback(() => {
    buttonOnClick?.()
    onClose()
  }, [buttonOnClick, onClose])

  return (
    <Styled.CustomPopup isOpen={isOpen} onClose={onClose}>
      <Styled.PreviewImagePopupContent>
        <Styled.PreviewImageWrapper $aspectRatio={aspectRatio}>
          {isImageLoading && (
            <Styled.SkeletonWrapper>
              <LoadingSkeleton />
            </Styled.SkeletonWrapper>
          )}
          <Styled.PreviewImage
            $aspectRatio={aspectRatio}
            src={url}
            alt={'preview-image'}
            onLoad={() => {
              setIsImageLoading(false)
            }}
          />
        </Styled.PreviewImageWrapper>
        <Styled.CustomButton onClick={handleButtonClick}>
          {buttonLabel || 'OK, close'}
        </Styled.CustomButton>
      </Styled.PreviewImagePopupContent>
    </Styled.CustomPopup>
  )
}
